<style lang="less"></style>

<template>
    <MenuList :menuList="menuList" @handleClicks="handleClicks(...arguments)" />
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import MenuList from "@/app/components/MenuList.vue";
    import checkCloudSpaceLimit from "@/app/utils/checkCloudSpaceLimit.js";

    @Component({
        components: {
            MenuList,
        },
    })
    export default class MyComponent extends Vue {
        customTListLength: number = 0;
        get menuList() {
            let list = [
                { label: this.$t("file") },
                { label: this.$t("template"), isRender: !this.otherTypeFile, showVip: !this.vip && this.customTListLength >= 2 },
            ];
            let resultList = list.filter((i) => (i.hasOwnProperty("isRender") ? i.isRender : true));
            return { list: resultList };
        }
        get userInfo() {
            return this.$store.state.user.userInfo;
        }
        get fileID() {
            return this.$store.state.ui.fileID;
        }
        get otherTypeFile() {
            // 群组文件和分享可编辑文件
            return this.$store.state.ui.isTeamFile || this.$store.state.ui.isShareEditFile;
        }
        get showUpgradeVal() {
            return this.$store.state.publicStore.showUpgrade;
        }

        initCustomData() {
            if (!this.$validateLogin()) return;
            if (window.EDCONFIG.IS_SDK) return;
            let user = {
                user_id: this.userInfo.user_id,
                token: this.userInfo.token,
                offset: 0,
                count: 20,
            };
            this.$edApi.getCustomTemplateList(user).then((e) => {
                let customTList = e.data || [];
                this.customTListLength = customTList.length;
            });
        }

        showCloudSpaceLimit() {
            if (!this.vip && this.showUpgradeVal != "cloudSpace") {
                this.$checkAuth({ type: "cloudSpace", buyTrigger: "cloudSpacePop" });
            } else if (this.vip && this.showUpgradeVal != "cloudSpaceVIP") {
                if (this.fuser) {
                    this.$bus.$emit("showCloudSpaceVipTips");
                } else {
                    this.$checkAuth({ type: "cloudSpaceVIP", buyTrigger: "cloudSpacePop" });
                }
            }
        }
        handleClicks(...args) {
            let index = args[0],
                event = args[1];
            event.stopPropagation();
            // index 为0或1，多于两种情况需优化条件语句
            if (index) {
                this.save2Template();
            } else {
                this.saveAs();
            }
        }
        closeDrop() {
            this.$emit("closeDrop");
        }

        saveAs() {
            this.$track("menu", "file", "save as");
            this.closeDrop();
            if (checkCloudSpaceLimit(this)) return;
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "saveAs",
            });
        }
        save2Template() {
            this.closeDrop();
            if (checkCloudSpaceLimit(this)) return;
            let urlSearch = this.$store.state.ui.fileInfo;
            this.$store
                .dispatch("autoSaveFile", { urlSearch })
                .then(() => {
                    this.$edApi
                        .addCustomTemplate({
                            user_id: this.userInfo.user_id,
                            token: this.userInfo.token,
                            data: {
                                obj_id: this.fileID,
                                platform: this.$store.state.publicStore.runPlatform,
                                file_key: this.$store.getters.fileKey,
                            },
                        })
                        .then((e) => {
                            if (e == "success") {
                                this.$edMessage.success(this.$t("addTemplateSucc"));
                                window.opener &&
                                    window.opener.postMessage(
                                        {
                                            type: "updateCustomTemplate",
                                        },
                                        location.origin
                                    );
                            } else if (e == "error") {
                                this.$checkAuth({ type: "personalTemplateNumber", buyTrigger: "personalTemplatePop" });
                            }
                            console.log(e);
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                })
                .catch((err) => {
                    if (err == "storageLimit") {
                        this.showCloudSpaceLimit();
                        this.$store.commit("setDialogState", {
                            type: "showDialog",
                            data: false,
                        });
                    }
                });
        }

        mounted() {
            this.initCustomData();
            this.$bus.$on("changeCustomTList", () => {
                // 第一次不会被触发
                this.initCustomData();
            });
            this.$once("hook:beforeDestroy", () => {
                this.$bus.$off("changeCustomTList", () => {
                    this.initCustomData();
                });
            });
        }

        created() {}
    }
</script>
<i18n>
{
    "zh": {
        "file": "云文件",
        "template": "个人模板",
        "addTemplateSucc": "添加模板成功"
    },
    "en": {
        "file": "Cloud file",
        "template": "Personal Template",
        "addTemplateSucc": "Add template success"
    },
    "fr": {
        "file": "Fichier cloud",
        "template": "Modèle personnel",
        "addTemplateSucc": "Ajouter un modèle avec succès"
    },
    "de": {
        "file": "Cloud-Datei",
        "template": "Persönliche Vorlage",
        "addTemplateSucc": "Vorlage erfolgreich hinzufügen"
    },
    "jp": {
        "file": "クラウドファイル",
        "template": "個人用テンプレート",
        "addTemplateSucc": "テンプレートが正常に追加されました"
    },
    "es": {
        "file": "Archivo en la nube",
        "template": "Plantilla personal",
        "addTemplateSucc": "Plantilla agregada correctamente"
    },
    "it": {
        "file": "File cloud",
        "template": "Modello Personale",
        "addTemplateSucc": "Aggiungi il modello con successo"
    },
    "pt": {
        "file": "Arquivo de nuvem",
        "template": "Modelo Pessoal",
        "addTemplateSucc": "Adicionar modelo com sucesso"
    },
    "tw": {
        "file": "雲端硬碟檔案",
        "template": "個人模板",
        "addTemplateSucc": "添加模板成功"
    },
    "kr": {
        "file": "클라우드 파일",
        "template": "개인 템플릿",
        "addTemplateSucc": "템플릿 추가 완료"
    }
}
</i18n>
